import React, { Component } from 'react';
import { Button, Form, List, Input } from 'antd';
import _ from 'lodash';

import { APIGEE_API_HOST } from '../../configs/env';
import whttp from '../../libs/whttp';
import { genFormItemAtrribute } from 'libs/FormHelper';
import styles from './styles.module.scss';

const INDEX_URL = _.get(window, 'VC_CONFIG.INDEX_URL');
const Locale = _.get(window, 'VC_CONFIG.Locale');

export default class StockList extends Component {
  state = {
    storeStockList: [],
    showPopUp: false,
  };

  getProductStock = (params) => {
    whttp.postApigeeApi(
      APIGEE_API_HOST + '/api/v1/oms/cec/website/stock/query',
      params,
      (state, res) => {
        if (state === false) {
          return console.log('發生錯誤');
        }

        if (res.code !== '200') {
          return console.log('ErrorReason', res.reason);
        }

        const stockInfo = res.data.stockInfo;
        const configOptions = this.props.app.options || {};
        const storeListAll = configOptions.stores || [];

        const matchedData = stockInfo
          .map((info) => {
            const matchingStore = storeListAll.find(
              (store) => store.sn === info.storeCode && store.status === true
            );

            if (matchingStore) {
              return {
                ...info,
                storeName: matchingStore.name,
                storeType: matchingStore.store_type_name === '量販' ? 1 : 2,
              };
            }
            return null;
          })
          .filter((item) => item !== null)
          .slice()
          .sort((a, b) => {
            return a.storeType - b.storeType;
          });

        this.setState({ storeStockList: matchedData, showPopUp: true });
      }
    );
  };
  handleClickClosePopup = () => {
    this.setState({ showPopUp: false });
  };
  handleClickShowPopup = () => {
    const productId = this.props.productId || '';
    const StoreListInfo = this.props.stores.listInfo || {};
    const StoreCode = StoreListInfo.rows.map((obj) => {
      return obj.sn;
    });
    this.getProductStock({ storeCode: StoreCode, productKey: productId });
  };

  render() {
    const productName = this.props.productName || '';
    return (
      <div>
        <Button onClick={() => this.handleClickShowPopup()} type='primary'>
          查詢分店庫存
        </Button>
        {this.state.showPopUp && (
          <div>
            <div
              onClick={() => this.handleClickClosePopup()}
              className={styles['mask']}
            />
            <div className={styles['container']}>
              <div
                className={styles['product-title']}
              >{`商品名稱：${productName}`}</div>
              <div className={styles['stock-list-wrapper']}>
                <List
                  dataSource={this.state.storeStockList}
                  renderItem={(item) => (
                    <List.Item>
                      <a
                        className={styles['stock-list']}
                        href={`${INDEX_URL}/store-info${
                          Locale == 'en_US' ? '-en' : ''
                        }/?store=${item.storeName}#tab=info`}
                      >
                        <div>{`${item.storeName}：${item.productStock}個`}</div>
                      </a>
                    </List.Item>
                  )}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

// 編輯器
export class StockListEditor extends Component {
  formRef = React.createRef();

  componentDidMount() {
    this.formRef.current.setFieldsValue(this.props.attributes);
  }
  handleInput = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/[^0-9]/g, '');
    e.target.value = numericValue;
  };
  render() {
    return (
      <div className='vu-blocks-editor'>
        <div class='components-placeholder__label'>
          <span class='block-editor-block-icon'>
            <div class='dashicons dashicons-megaphone' />
          </span>
          商品代碼設定
        </div>
        <Form
          ref={this.formRef}
          name='basic'
          className='basicForm'
          layout='vertical'
          onValuesChange={(changedFields, allFields) =>
            this.props.setAttributes(changedFields)
          }
        >
          <Form.Item {...genFormItemAtrribute('productId', '商品代碼')}>
            <Input
              placeholder='請輸入商品十一碼'
              onInput={this.handleInput}
              maxLength={11}
            />
          </Form.Item>
          <Form.Item {...genFormItemAtrribute('productName', '商品名稱')}>
            <Input placeholder='請輸入商品名稱' />
          </Form.Item>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/stock/stock-list.js